import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { Box, Text } from '@miro-site/core';
import { useTheme } from 'styled-components';
import { useTranslation } from 'next-i18next';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * Used to output flip card tags that a user can set
 * in our contentful general templates collection
 */
export var CardTags = function CardTags(_ref) {
  var descriptionStyles = _ref.descriptionStyles,
      headingStyles = _ref.headingStyles,
      tags = _ref.tags;

  if (!Array.isArray(tags) || !(tags !== null && tags !== void 0 && tags.length)) {
    return null;
  }

  var theme = useTheme();

  var _useTranslation = useTranslation('common'),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs(Box, {
    $styles: {
      backgroundColor: 'var(--wcds-colors-body-primary)',
      padding: [16, 20],
      marginBottom: 24,
      borderRadius: 8
    },
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h4",
      $color: "primaryIndigo",
      $mb: 12,
      $styles: _objectSpread({
        fontWeight: 700,
        fontSize: 14,
        lineHeight: 20
      }, headingStyles),
      children: t('works-best-for')
    }), /*#__PURE__*/_jsx(Text, {
      $variant: ['p1', 'p2', 'p2', 'p2'],
      $styles: _objectSpread({
        color: theme.templates.colors.secondary60,
        fontSize: 14,
        lineHeight: 20
      }, descriptionStyles),
      children: tags.join(', ')
    })]
  });
};